import { FC, memo } from 'react';
import cc from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import { createArray } from 'utils/helpers/create-fake-array';
import { ISelectedGamesSkeletonProps } from 'newcomponents/Shared/sportsbook/SelectedGameCard/types';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

const SELECTED_GAME_CARD_SKELETON_COUNT = 3;

export const AdvancedSelectedGameCardSkeleton: FC<ISelectedGamesSkeletonProps> =
  memo(({ aspectRatio, coverMode, moduleId }) => {
    const cssVars = `
  .selectedSportsModuleSkeleton_${moduleId} {
    --SS-card-aspect-ratio: ${aspectRatio || 0}%;
  }
  `;

    return (
      <>
        <style>{cssVars}</style>
        <div
          className={cc([
            'advancedSelectedGameCard',
            'advancedSelectedGameCard__skeleton',
            `selectedSportsModuleSkeleton_${moduleId}`,
            {
              advancedSelectedGameCard__cover: !!Number(coverMode)
            }
          ])}
        >
          <div className="advancedSelectedGameCard__container">
            <div className="advancedSelectedGameCard__header">
              <div className="advancedSelectedGameCard__header__block">
                <div className="advancedSelectedGameCard__header__block__icons">
                  <Skeleton.Avatar active size={EIconSize._16} shape="circle" />
                  <Skeleton.Avatar active size={EIconSize._16} shape="circle" />
                </div>
                <span className="advancedSelectedGameCard__header__block__competition">
                  <Skeleton.Input
                    style={{ width: '80px', height: '18px' }}
                    active
                  />
                </span>
              </div>

              <div className="advancedSelectedGameCard__header__block">
                <div className="advancedSelectedGameCard__header__block__date">
                  <Skeleton.Input
                    style={{ width: '50px', height: '15px' }}
                    active
                  />
                </div>

                <div className="advancedSelectedGameCard__header__block__favStatistic">
                  <Skeleton.Input
                    style={{ width: '48px', height: '18px' }}
                    active
                  />
                  <Skeleton.Avatar active size={EIconSize._16} shape="circle" />
                </div>
              </div>
            </div>

            <div className="advancedSelectedGameCard__body">
              <div className="advancedSelectedGameCard__body__teamContent">
                <div className="advancedSelectedGameCard__body__teamInfo">
                  <div className="advancedSelectedGameCard__body__teamInfo__block">
                    <Skeleton.Input
                      style={{ width: '80px', height: '20px' }}
                      active
                    />

                    <Skeleton.Avatar
                      active
                      size={EIconSize._16}
                      shape="circle"
                    />
                  </div>
                  <span className="advancedSelectedGameCard__body__teamInfo__block__separator">
                    <Skeleton.Input
                      style={{ width: '5px', height: '4px' }}
                      active
                    />
                  </span>
                  <div className="advancedSelectedGameCard__body__teamInfo__block">
                    <Skeleton.Avatar
                      active
                      size={EIconSize._16}
                      shape="circle"
                    />
                    <Skeleton.Input
                      style={{ width: '80px', height: '20px' }}
                      active
                    />
                  </div>
                </div>
              </div>
              <div className="advancedSelectedGameCard__body__odds">
                {createArray(SELECTED_GAME_CARD_SKELETON_COUNT).map(key => (
                  <Skeleton
                    key={key}
                    title={{
                      style: {
                        marginTop: 0,
                        marginBottom: 0,
                        height: 32,
                        width: 'auto'
                      }
                    }}
                    paragraph={false}
                    active
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  });
